<template>
  <input
    class="native-date-input"
    type="date"
    :value="formattedValue"
    :disabled="disabled"
    :aria-label="ariaLabel"
    @input="handleInput"
  />
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: {
    type: Date,
    default: null
  },
  disabled: {
    type: Boolean,
    default: false
  },
  ariaLabel: {
    type: String,
    default: 'Date'
  }
});

const emit = defineEmits(['update:modelValue', 'date-select']);

const pad = value => String(value).padStart(2, '0');

const formattedValue = computed(() => {
  if (!(props.modelValue instanceof Date) || Number.isNaN(props.modelValue.getTime())) return '';

  return [
    props.modelValue.getFullYear(),
    pad(props.modelValue.getMonth() + 1),
    pad(props.modelValue.getDate())
  ].join('-');
});

function handleInput(event) {
  const parts = event.target.value.split('-').map(Number);
  if (parts.length !== 3 || parts.some(Number.isNaN)) return;

  const selectedDate = props.modelValue instanceof Date && !Number.isNaN(props.modelValue.getTime())
    ? new Date(props.modelValue)
    : new Date();
  selectedDate.setFullYear(parts[0], parts[1] - 1, parts[2]);
  emit('update:modelValue', selectedDate);
  emit('date-select', selectedDate);
}
</script>

<style scoped>
.native-date-input {
  width: 100%;
  min-width: 9rem;
  padding: 3px 3px;
  color-scheme: dark;
}

.native-date-input:disabled {
  cursor: default;
}
</style>
